{
  "meta": {
    "title": "Impressum | Khromatik",
    "description": "Impressum, Datenschutz und Angaben zu Khromatik Digital S.R.L."
  },
  "heading": {
    "main": "Impressum"
  },
  "legalBasis": "Angaben zum Diensteanbieter gemäß den anwendbaren Informationspflichten.",
  "company": {
    "name": "KHROMATIK DIGITAL S.R.L.",
    "address": "Str. Armoniei, nr. 23A, ap. B1\nTimișoara, Rumänien",
    "regLabel": "Handelsregister (Rumänien):",
    "regValue": "J2026019403001",
    "cuiLabel": "Steuerliche Identifikationsnummer (CUI):",
    "cuiValue": "54324200"
  },
  "contact": {
    "heading": "Kontakt:",
    "emailLabel": "E-Mail:"
  },
  "privacy": {
    "title": "Datenschutzerklärung",
    "leadTitle": "Datenschutz",
    "lead": "Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.",
    "controllerTitle": "Verantwortlicher",
    "controllerAddress": "KHROMATIK DIGITAL S.R.L.\nStr. Armoniei, nr. 23A, ap. B1\nTimișoara, Rumänien",
    "accessDataTitle": "Zugriffsdaten",
    "accessDataIntro": "Beim Besuch dieser Website erhebt der Webhoster automatisch Informationen über Zugriffe auf die Seite (sogenannte Server-Logfiles). Zu den Zugriffsdaten gehören:",
    "accessDataList": {
      "i1": "Besuchte Website",
      "i2": "Uhrzeit zum Zeitpunkt des Zugriffes",
      "i3": "Menge der gesendeten Daten in Byte",
      "i4": "Quelle/Verweis, von welchem Sie auf die Seite gelangten",
      "i5": "Verwendeter Browser",
      "i6": "Verwendetes Betriebssystem",
      "i7": "Verwendete IP-Adresse (ggf. gekürzt oder anonymisiert)"
    },
    "accessDataOutro": "Die erhobenen Daten dienen der Sicherheit, der Fehleranalyse und statistischen Auswertungen. Der Websitebetreiber behält sich vor, die Server-Logfiles nachträglich zu überprüfen, sollten konkrete Anhaltspunkte auf eine rechtswidrige Nutzung hinweisen.",
    "cookiesTitle": "Cookies",
    "cookiesP1": "Diese Website nutzt technisch notwendige Speicherung im Browser (z. B. localStorage) für Ihre Sprachwahl und Ihre Entscheidung zur Cookie-Einwilligung. Optional können Sie der Nutzung von Google Analytics und Microsoft Clarity zustimmen; diese Dienste können Cookies und ähnliche Technologien einsetzen. Die Einwilligung erteilen oder widerrufen Sie über den Hinweis beim ersten Besuch oder jederzeit über den Link „Cookie-Einstellungen“ im Footer. Ohne Zustimmung werden diese Analyse-Tools nicht geladen.",
    "cookiesP2": "Eingebettete Inhalte (z. B. Vimeo-Videos) können durch Dritte eigene Cookies setzen; darauf haben wir keinen direkten Einfluss. Sie können die Speicherung von Cookies in Ihrem Browser einschränken oder löschen.",
    "rightsTitle": "Ihre Rechte",
    "rightsP1": "Soweit anwendbar, haben Sie Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch und Datenübertragbarkeit.",
    "rightsP2": "Wenn Sie Fragen zum Thema Datenschutz haben, können Sie sich unter den oben genannten Kontaktdaten an uns wenden."
  },
  "disclaimer": {
    "title": "Haftungsausschluss",
    "contentTitle": "Haftung für Inhalte",
    "contentP1": "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
    "contentP2": "Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen entfernen wir diese Inhalte umgehend.",
    "linksTitle": "Haftung für Links",
    "linksP1": "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
    "linksP2": "Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen entfernen wir derartige Links umgehend."
  },
  "credits": {
    "title": "Bildnachweise",
    "photosPrefix": "Fotos von",
    "iconsPrefix": "Icons von"
  }
}
